import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		content: {
			display: 'flex',
			alignItems: 'flex-start',
		},

		image: {
			width: theme.spacing(4),
			height: theme.spacing(4),
			flexShrink: 0,
			marginRight: theme.spacing(2.6),
			marginTop: theme.spacing(-0.2),
			'& img': {
				height: '100%',
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},
	}),
	{ name: 'Content-Content8-item' },
)

export default useStyles
